import { AuthProvider, useAuth } from './auth/AuthContext';
import Login from './components/Login';
import RevoyaDashboard from './RevoyaDashboard';

function AppContent() {
  const { user, logout } = useAuth();

  // undefined = Firebase still resolving session — show nothing to avoid flash
  if (user === undefined) return null;
  if (!user) return <Login />;
  return <RevoyaDashboard user={user} onLogout={logout} />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
